<template>
  <div id="inner">
    <form>
    <b-row>
      <b-col sm="12">
        <h1>
          Schrijf u in als woningzoekende
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="6">
        <b-row :class="{'is-invalid': ($v.user.email.$dirty ? $v.user.email.$invalid : false)}">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-user"></i>
            <label for="email">E-mailadres*</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                    type="email"
                    id="email"
                    v-model="user.email"
                    autocomplete="off"
                    size="sm"
                    placeholder=""
                    v-bind:readonly="false"
                    @change="$v.user.email.$touch"
                    :state="$v.user.email.$dirty ? !$v.user.email.$invalid : undefined"
                    required

            />
            <div class="invalid-feedback" v-if="($v.user.email.$dirty ? $v.user.email.$invalid : false)">
              Uw e-mailadres is niet goed
            </div>
          </b-col>
        </b-row>
        <b-row :class="{'is-invalid': ($v.user.dob.$dirty ? $v.user.dob.$invalid : false)}">
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-calendar-star"></i>
            <label for="dob">Geboortedatum*</label>
          </b-col>
          <b-col sm="6">
            <b-row class="date-wrap">
              <b-form-select
                      class="col-3 day-input"
                      v-model="user.dob_day"
                      autocomplete="off"
                      :options="formData.days"
                      @change="checkDate"
                      required
              />
              <b-form-select
                      class="col-5"
                      v-model="user.dob_month"
                      autocomplete="off"
                      :options="formData.months"
                      @change="checkDate"
                      required
              />
              <b-form-select
                      class="col-4"
                      v-model="user.dob_year"
                      autocomplete="off"
                      :options="formData.years"
                      @change="checkDate"
                      required
              />
              <div class="invalid-feedback" v-if="($v.user.dob.$dirty ? $v.user.dob.$invalid : false)">
                Dit moet een bestaande datum van teminste 18 jaar geleden zijn
              </div>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="spacer d-none d-sm-block">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <h2>
              Bedenk direct een wachtwoord
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-user-lock"></i>
            <label for="password_new">Wachtwoord*</label>
          </b-col>
          <b-col sm="6">
            <b-input-group>
              <b-form-input
                      :type="show_password_new  ? 'text' : 'password'"
                      id="password_new"
                      v-model="user.password_new"
                      size="sm"
                      v-bind:readonly="false"
                      autocomplete="off"
                      placeholder=""
                      @focus="setActiveInput('password')"
                      @blur="setActiveInput(null)"
                      @input="doCheckPassword"
                      required
              />
              <password-eye @click="show_password_new = !show_password_new" :state="show_password_new"/>
            </b-input-group>

          </b-col>
          <div class="card d-none d-lg-block" id="password-card" v-if="activeInput === 'password'">
            <div class="card-body">
              <div class="card-title">
                Uw wachtwoord:
              </div>
              <ul class="pass_list">
                <li v-bind:class="{ is_valid: password.contains_eight_characters, pass_check: true}">Minimaal 8
                  tekens
                </li>
                <li v-bind:class="{ is_valid: password.contains_number, pass_check: true }">Bevat minimaal 1 cijfer</li>
                <li v-bind:class="{ is_valid: password.contains_uppercase, pass_check: true }">Bevat minimaal 1
                  hoofdletter
                </li>
                <li v-bind:class="{ is_valid: password.contains_special_character, pass_check: true }">Bevat minimaal 1
                  leesteken
                </li>
                <li v-bind:class="{ is_valid: password.password_match, pass_check: true }">Beide wachtwoorden komen
                  overeen
                </li>
              </ul>
            </div>
          </div>
        </b-row>
        <b-row>
          <b-col sm="5" class="form-label">
            <i class="fad fax fa-user-lock"></i>
            <label for="password_repeat">Wachtwoord bevestigen*</label>
          </b-col>
          <b-col sm="6">
            <b-input-group>
              <b-form-input
                      :type="show_password_new  ? 'text' : 'password'"
                      id="password_repeat"
                      autocomplete="off"
                      v-model="user.password_repeat"
                      size="sm"
                      v-bind:readonly="false"
                      placeholder=""
                      @focus="setActiveInput('password')"
                      @blur="setActiveInput(null)"
                      @input="doCheckPassword"
                      required
              />
              <password-eye @click="show_password_new = !show_password_new" :state="show_password_new"/>
            </b-input-group>

          </b-col>
          <div class="card d-block d-lg-none" v-if="activeInput === 'password'">
            <div class="card-body">
              <div class="card-title">
                Uw wachtwoord:
              </div>
              <ul class="pass_list">
                <li v-bind:class="{ is_valid: password.contains_eight_characters, pass_check: true}">Minimaal 8
                  tekens
                </li>
                <li v-bind:class="{ is_valid: password.contains_number, pass_check: true }">Bevat minimaal 1 cijfer</li>
                <li v-bind:class="{ is_valid: password.contains_uppercase, pass_check: true }">Bevat minimaal 1
                  hoofdletter
                </li>
                <li v-bind:class="{ is_valid: password.contains_special_character, pass_check: true }">Bevat minimaal 1
                  leesteken
                </li>
                <li v-bind:class="{ is_valid: password.password_match, pass_check: true }">Beide wachtwoorden komen
                  overeen
                </li>
              </ul>
            </div>
          </div>
        </b-row>
        <b-row>
          <b-col sm="12">
            <br/>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-alert variant="danger" :show="err.length">
              {{ err }}
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" offset-sm="5" class="text-center">
            <b-button variant="success" class="text-center pull-right" @click="openModal">
              Schrijf mij in
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="5" offset-lg="1" class="form-info-block d-none d-lg-block">
        <p>
          <strong>
            <i>
              Nog niet ingeschreven bij {{skin.region}}? Meld u dan nu aan als woningzoekende!
              <template v-if="skin.paid && skin.paid_recurring">
                Inschrijven bij {{skin.region}} kost &euro;{{skin.paid_cost}}.
              </template>
              <template v-else-if="skin.paid && !skin.paid_recurring">
                Inschrijven bij {{skin.region}} kost eenmalig &euro;{{skin.paid_cost}}.
              </template>
              <template v-else>
                Inschrijven bij {{skin.region}} is gratis.
              </template>
            </i>
          </strong><br/>
          <strong>Betaal uw inschrijfgeld binnen 7 dagen na aanmelding, anders wordt deze ongedaan gemaakt.</strong>
        </p>
        <p>
          <i>
            Wilt u zich samen met uw partner inschrijven? Houd dan het e-mailadres van uw partner bij de hand.
          </i>
        </p>
        <ul class="list-unstyled" id="promolist">
          <li>
            <i class="fad fax fa-phone-laptop"></i> <span>Inloggen vanaf PC, laptop of telefoon</span>
          </li>
          <li>
            <i class="fad fax fa-user-lock"></i> <span>Eenvoudig samen inschrijven</span>
          </li>
          <li>
            <i class="fad fax fa-euro-sign"></i> <span>Houd uw inkomen bij de hand</span>
          </li>
          <li v-if="!skin.paid">
            <i class="fad fax fa-credit-card"></i> <span>Bankpas niet nodig! Uw inschrijving is gratis</span>
          </li>
          <li v-else-if="skin.paid">
            <i class="fad fax fa-credit-card"></i> <span>U heeft uw bankpas nodig</span>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <br/>
      <br/>
      <br/>
    </b-row>
    <b-row>
      <b-col sm="12" class="text-left text-muted">
        &nbsp;
      </b-col>
    </b-row>

    <b-modal
        id="alertToCarryOver"
        title-html="<i class='far fax fa-check'></i>&nbsp;Voor de zekerheid"
        size="lg"
        ok-title="Ik had nog geen account"
        ok-variant="success"
        @ok="closeCarryOver"
        cancel-title="Mijn gegevens overzetten"
        cancel-variant="success"
        @cancel="carryOverLink"
        hide-header-close
    >
      <b-row>
        <b-col>
          <h1>
            Heeft u al een woningzoekende account bij Groninger Huis?
          </h1>
          <p>
            Groninger Huis is overgestapt op een nieuw systeem voor het aanbieden van haar woningen. Als u al een account als Woningzoekende bij Groninger Huis had, kunt u uw gegevens overzetten en zo uw inschrijfduur behouden.
          </p>
          <p>
            Klik hieronder op "mijn gegevens overzetten" om naar de speciale website te gaan. Uw inschrijving wordt dan aangemaakt op basis van uw oude inschrijfduur.
          </p>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
            id="registrationConfirmModal"
            title-html="<i class='far fax fa-check'></i>&nbsp;Voor de zekerheid"
            size="lg"
            ok-title="Dit zijn mijn gegevens"
            ok-variant="success"
            @ok="createAccount"
            cancel-title="Nee, deze gegevens kloppen niet"
            cancel-variant="danger"
            @cancel="closeModal"
            hide-header-close
    >
      <b-row>
        <b-col sm="12">
          <p>
            Met deze gegevens gaat u zich nu inschrijven.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <strong>Let op:</strong> U kunt uw e-mailadres en geboortedatum later niet meer aanpassen. Vul uw gegevens dus goed in.
        </b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col sm="12">
          <b-row>
            <b-col sm="5" class="form-label">
              <i class="fad fax fa-user"></i>
              <label for="email">E-mailadres*</label>
            </b-col>
            <b-col sm="6">
              <b-form-input
                      type="email"
                      autocomplete="off"
                      id="email"
                      v-model="$v.user.email.$model"
                      size="sm"
                      placeholder=""
                      :state="$v.user.email.$dirty ? !$v.user.email.$invalid : undefined"
                      required

              />
              <div class="invalid-feedback" v-if="($v.user.email.$dirty ? $v.user.email.$invalid : false)">
                Uw e-mailadres is niet goed
              </div>
            </b-col>
          </b-row>
          <b-row :class="{'is-invalid': ($v.user.dob.$dirty ? $v.user.dob.$invalid : false)}">
            <b-col sm="5" class="form-label">
              <i class="fad fax fa-calendar-star"></i>
              <label for="dob">Geboortedatum*</label>
            </b-col>
            <b-col sm="6">
              <b-row class="date-wrap">
                <b-form-select
                        class="col-3 day-input"
                        v-model="user.dob_day"
                        autocomplete="off"
                        :options="formData.days"
                        @change="checkDate"
                        required
                />
                <b-form-select
                        class="col-5"
                        v-model="user.dob_month"
                        autocomplete="off"
                        :options="formData.months"
                        @change="checkDate"
                        required
                />
                <b-form-select
                        class="col-4"
                        v-model="user.dob_year"
                        autocomplete="off"
                        :options="formData.years"
                        @change="checkDate"
                        required
                />
                <div class="invalid-feedback" v-if="($v.user.dob.$dirty ? $v.user.dob.$invalid : false)">
                  Dit moet een bestaande datum van tenminste 18 jaar geleden zijn
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <p>
            Zijn dit uw gegevens en zijn ze goed ingevuld?
          </p>
        </b-col>
      </b-row>
    </b-modal>
    </form>
    <vuelidateErrorDialog :validator="$v.user" :state="errDialogVisible" @onClose="errDialogVisible = false"/>
  </div>
</template>

<script>
import { getDays, getMonths, getYears, checkPassword } from '../_helpers'
import { dobAboveEighteen, passwordIsValid } from '../_helpers/validators'
import { required, email, helpers } from 'vuelidate/lib/validators'
import { accountService } from '../_services'
import PasswordEye from '@/components/PasswordEye'
import vuelidateErrorDialog from "./VuelidateErrorDialog"

export default {
  name: 'NewAccount',
  components: { PasswordEye, vuelidateErrorDialog },
  data: () => {
    return {
      show_password_new: false,
      err: '',
      errDialogVisible: false,
      user: {
        email: '',
        dob_day: '',
        dob_month: '',
        dob_year: '',
        dob: '',
        password_new: '',
        password_repeat: '',
        password_valid: false
      },
      formData: {
        days: getDays(),
        months: getMonths(),
        years: getYears(18, 100)
      },
      activeInput: '',
      password: {
        valid_password: false
      },
      skin: {
        paid: process.env.VUE_APP_PAID === 'true',
        paid_recurring: process.env.VUE_APP_PAYMENT_RECURRING === 'true',
        paid_cost: process.env.VUE_APP_PAYMENT_COST,
        region: process.env.VUE_APP_REGION,
      }
    }
  },
  watch: {
    'password.valid_password': function(newVal) {
      this.user.password_valid = newVal
    }
  },
  validations: {
    user: {
      email: { required, email },
      dob: { required, dobAboveEighteen },
      password_valid: { required, passwordIsValid },
    }
  },
  mounted () {
    /*if you're already logged in, you don't belong here*/
    if (window.localStorage.getItem('user') !== null) {
      this.$router.push('/gegevens')
    }
    this.$emit('childInitialized', {
      title: 'Regel uw inschrijving'
    })
    /*this.$bvModal.show('alertToCarryOver')*/
  },
  methods: {
    setActiveInput (data) {
      if (data !== this.activeInput) {
        if (data === 'password') {
          this.doCheckPassword()
        }
        this.activeInput = data
      }
    },
    doCheckPassword () {
      this.password = checkPassword(this.user.password_new, this.user.password_repeat)
    },
    checkDate () {
      if (this.user.dob_day !== '' && this.user.dob_month !== '' && this.user.dob_year !== '') {
        this.user.dob = this.user.dob_year + '-' + this.user.dob_month + '-' + this.user.dob_day
        this.$v.user.dob.$touch()
      }
    },
    openModal () {
      if (!this.$v.$invalid && this.password.valid_password) {
        this.$bvModal.show('registrationConfirmModal')
      } else {
        this.$v.$touch()
        this.errDialogVisible = true
      }
    },
    closeModal () {
      this.$bvModal.hide('registrationConfirmModal')
      this.$nextTick(() => { this.$v.$reset() })
    },
    closeCarryOver() {
      this.$bvModal.hide('alertToCarryOver')
    },
    carryOverLink() {
      window.location.href = 'https://welkom.ikzoekeengroningerhuis.nl'
    },
    createAccount () {
      if (!this.$v.$invalid && this.password.valid_password) {
        this.err = ''
        accountService.post(this.user.dob, this.user.email, this.user.password_new).then(
                (data) => {
                  window.location.href = `../passthrough.cfm?token=${data}`
                },
                (err) => {
                  this.err = err
                }
        )
      } else {
        this.$bvModal.show('registrationNeedPassword')
      }
      this.closeModal()
    }
  }
}
</script>

<style scoped>
ul.pass_list {
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pass_check {
  margin-bottom: 8px;
  position: relative;
}

.pass_check:before {
  content: "";
  width: 0%;
  height: 2px;
  background: #2ecc71;
  position: absolute;
  left: 0;
  top: 50%;
  display: block;
  transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.is_valid {
  color: rgba(136, 152, 170, 0.8);
}

.is_valid:before {
  width: 100%;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
